import * as yup from 'yup';

import { TipoParametroChoiceEnum } from '@/shared/constants';
import { fieldStateYupValidation } from '@/shared/utils/validationSchema';

export const parametroFormSchema = yup.object({
  slug: yup
    .string()
    .required('El campo slug es requerido')
    .max(200, 'El campo slug no debe exceder los 200 caracteres'),
  nombre: yup
    .string()
    .required('El campo nombre es requerido')
    .max(100, 'El campo nombre no debe exceder los 100 caracteres'),

  descripcion: yup
    .string()
    .required('El campo descripcion es requerido')
    .max(255, 'El campo descripcion no debe exceder los 255 caracteres'),
  codigo: yup
    .string()
    .required('El campo codigo es requerido')
    .max(100, 'El campo codigo no debe exceder los 100 caracteres'),
  numero_referencia: yup.string().optional().nullable(),

  estado: fieldStateYupValidation,

  tipo: yup
    .string()
    .required('El campo tipo es requerido')
    .max(200, 'El campo tipo no debe exceder los 200 caracteres'),

  valor: yup
    .string()
    .required()
    .when('tipo', {
      is: TipoParametroChoiceEnum.TEXTO,
      then: schema =>
        schema.max(255, 'El campo valor no debe exceder los 255 caracteres'),
    })
    .when('tipo', {
      is: TipoParametroChoiceEnum.NUMERICO,
      then: schema => {
        const regex = /^\d+(\.\d{1,2})?$/;
        return schema.matches(
          regex,
          'El campo valor debe ser un número con hasta dos decimales'
        );
      },
    })
    .when('tipo', {
      is: TipoParametroChoiceEnum.JSON,
      then: schema =>
        schema.test(
          'is-json',
          'El campo valor debe ser un JSON válido',
          value => {
            try {
              JSON.parse(value);
              return true;
            } catch (e) {
              return false;
            }
          }
        ),
    })
    .when('tipo', {
      is: TipoParametroChoiceEnum.ARRAY,
      then: schema =>
        schema.test(
          'is-array',
          'El campo valor debe ser un array válido',
          value => {
            const isValid = /^\[.*\]$/.test(value);
            if (!isValid) return false;

            try {
              JSON.parse(value);
              return true;
            } catch (e) {
              return false;
            }
          }
        ),
    }),
});
